import { IBaseResponseModel } from "../../models/common/models.type";
import {
  ILoginResponse,
  ILoginRequest,
  IUpdateFcmTokenReq
} from "../../models/auth";
import api from "../remote/baseApi";
import ApiEndpoints from "../remote/apiEndpoints";
import { envConfig } from "../../config/env.config";
import {
  connectSignal,
  disconnectSignal
} from "../../services/api/signalr.Service";

const API_AUTH = ApiEndpoints.AUTH;
const baseURL = envConfig.ACCOUNT_ENDPOINT;

const loginWithPassword = async (
  login: ILoginRequest
): Promise<IBaseResponseModel<string>> => {
  const res = await api.post<ILoginRequest, IBaseResponseModel<string>>(
    baseURL,
    API_AUTH.LOGIN_WITH_PASSWORD.url,
    login
  );
  if (res.success) {
    await connectSignal(res.data); // ✅ Kết nối SignalR sau khi login thành công
  }

  return res;
};

const adminLoginWithPassword = async (
  login: ILoginRequest
): Promise<IBaseResponseModel<ILoginResponse>> => {
  return api.post(baseURL, API_AUTH.ADMIN_LOGIN_WITH_PASSWORD.url, login);
};

const updateFcmToken = async (
  updateFcmToken: IUpdateFcmTokenReq
): Promise<IBaseResponseModel<string>> => {
  return api.put(baseURL, API_AUTH.UPDATE_FCM_TOKEN.url, updateFcmToken);
};

const logout = async (
  fireBaseToken: string
): Promise<IBaseResponseModel<any>> => {
  const res = await api.post<any, IBaseResponseModel<any>>(
    baseURL,
    API_AUTH.LOGOUT.url,
    { fireBaseToken }
  );

  if (res.success) {
    await disconnectSignal(); // ✅ Ngắt kết nối SignalR sau khi logout thành công
  }

  return res;
};

const syncOidcSession = async (): Promise<IBaseResponseModel<any>> => {
  // console.log('[AUTH SERVICE] syncOidcSession - Request Info:', {
  //   baseURL,
  //   endpoint: API_AUTH.SYNC_OIDC_SESSION.url,
  //   fullUrl: `${baseURL}${API_AUTH.SYNC_OIDC_SESSION.url}`,
  //   timestamp: new Date().toISOString()
  // });

  try {
    const response = await api.post<{}, IBaseResponseModel<any>>(
      baseURL,
      API_AUTH.SYNC_OIDC_SESSION.url,
      {}
    );
    // console.log('[AUTH SERVICE] syncOidcSession - Response Success:', {
    //   success: response.success,
    //   message: response.message,
    //   data: response.data,
    //   timestamp: new Date().toISOString()
    // });
    return response;
  } catch (error) {
    console.error('[AUTH SERVICE] syncOidcSession - Error:', {
      error,
      errorMessage: error instanceof Error ? error.message : 'Unknown error',
      errorStack: error instanceof Error ? error.stack : undefined,
      timestamp: new Date().toISOString()
    });
    throw error;
  }
};

const AuthService = {
  loginWithPassword,
  adminLoginWithPassword,
  updateFcmToken,
  logout,
  syncOidcSession
};

export default AuthService;
